export enum VerticalSide {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}
